/**
 * These are utils duplicated from the core workspace, copy-pasted here for quick solution.
 */
import tinycolor from 'tinycolor2';

export function alpha(color: string, a: number) {
    return tinycolor(color).setAlpha(a).toRgbString();
}
